import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';

import OrganisationsView from './show/OrganisationView';
import UnitV1Profil from './show/UnitV1Profil';
import UnitOptionProfil from './show/UnitOptionProfil';
import {
  ArmyListUnitProfilV1Presenter
} from '@Selectors/builder/myArmyList/make/unit/show/ArmyListUnitProfilV1Presenter';

interface IArmyListUnitShowV1Props {
  armyListUnitId: string
}

const ArmyListUnitShowV1: React.FC<ArmyListUnitShowV1Props> = ({armyListUnit}) => {

  return (
    <section className="mt-2 row">
      <div className="col-12 col-md-6">
        <OrganisationsView organisations={armyListUnit.organisations}/>
      </div>
      <UnitV1Profil troops={armyListUnit.troops}/>
      <UnitOptionProfil modelRules={armyListUnit.modelRules} notes={armyListUnit.item.notes} magic={armyListUnit.item.magic}/>
    </section>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListUnitShowV1Props) => ({
  armyListUnit: ArmyListUnitProfilV1Presenter(state, owsProps),
});

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitShowV1);

type ArmyListUnitShowV1Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
